var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "#FAF7F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1848 17.2864L12.4181 7.31477C12.3847 7.2885 12.3446 7.27218 12.3024 7.26768C12.2602 7.26317 12.2175 7.27067 12.1794 7.2893C12.1412 7.30793 12.1091 7.33694 12.0867 7.37301C12.0643 7.40908 12.0525 7.45073 12.0527 7.49319V9.68235C12.0527 9.82112 12.1179 9.95422 12.2255 10.0392L22.4208 18L12.2255 25.9609C12.115 26.0458 12.0527 26.1789 12.0527 26.3177V28.5069C12.0527 28.6966 12.2708 28.8014 12.4181 28.6853L25.1848 18.7137C25.2933 18.6291 25.3811 18.5208 25.4415 18.3971C25.5019 18.2734 25.5333 18.1376 25.5333 18C25.5333 17.8624 25.5019 17.7266 25.4415 17.6029C25.3811 17.4793 25.2933 17.371 25.1848 17.2864Z",
    fill: "#508BEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#D9D1C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.ceae36024b5d49d7a81ed51ee5212168.svg";
export { ForwardRef as ReactComponent };